import {MenuItem} from "@/interfaces/MenuItem";
import { RouteNamesEnum } from "./routes";
export const pagesNav: MenuItem[] = [
  {
    name: 'Company info',
    route: RouteNamesEnum.CompanyInfo,
    icon: 'assets/icon/company.svg',
    urls: ['company-info']
  },
  {
    name: 'Messages',
    route: RouteNamesEnum.Messages,
    icon: 'assets/icon/chat.svg',
    urls: ['messages', 'chat']
  },
  {
    name: 'Address Book',
    route: RouteNamesEnum.AddressBook,
    icon: 'assets/icon/address-book.svg',
    urls: ['address-book', 'view-contact', 'add-contact', 'edit-contact']
  },
  {
    name: 'Users',
    route: RouteNamesEnum.Users,
    icon: 'assets/icon/users.svg',
    urls: ['users', 'user-view', 'user-edit', 'user-add']
  },
  {
    name: 'My Fleet',
    route: RouteNamesEnum.MyFleet,
    icon: 'assets/icon/fleet-delivery.svg',
    urls: ['my-fleet', 'add-vehicle', 'edit-vehicle']
  },
  {
    name: 'Live Availability',
    route: RouteNamesEnum.LiveAvailability,
    icon: 'assets/icon/location-availability.svg',
    urls: ['live-availability']
  },
  {
    name: 'Documents',
    route: RouteNamesEnum.Documents,
    icon: 'assets/icon/doc.svg',
    urls: ['documents', 'documents-list', 'add-view-document']
  },
  {
    name: 'Locations',
    route: RouteNamesEnum.Locations,
    icon: 'assets/icon/locations.svg',
    urls: ['locations', 'location-edit', 'location-add']
  },
  {
    name: 'Subscription',
    route: RouteNamesEnum.Subscription,
    icon: 'assets/icon/subscription.svg',
    urls: ['subscription', 'subscription-edit', 'subscription-invoices', 'subscription-edit-cards', 'subscription-add-card']
  },
  {
    name: 'Accounting',
    route: RouteNamesEnum.Accounting,
    icon: 'assets/icon/accounting.svg',
    urls: ['accounting', 'accounting-driver', 'accounting-poster', 'accounting-invoices-driver', 'accounting-invoices-poster', 'view-invoice']
  },
  {
    name: 'Member Benefits',
    route: RouteNamesEnum.Benefits,
    icon: 'assets/icon/thumbs-up.svg',
    urls: ['member-benefits', 'factoring']
  },
  {
    name: 'Directory',
    route: RouteNamesEnum.Directory,
    icon: 'assets/icon/directory.svg',
    urls: ['directory']
  },
  {
    name: 'Settings',
    route: RouteNamesEnum.Settings,
    icon: 'assets/icon/settings.svg',
    urls: ['settings', 'job-proximity-alerts', 'job-notification-settings', 'api-callbacks', 'password', 'demo-account']
  },
  {
    name: 'Help',
    route: RouteNamesEnum.Help,
    icon: 'assets/icon/question.svg',
    isAlwaysVisible: true,
    urls: ['help']
  },
  {
    name: 'Logout',
    route: RouteNamesEnum.Logout,
    icon: 'assets/icon/exit.svg',
    isAlwaysVisible: true
  }
];